export default "__VITE_ASSET__EkNGfkvp__"